<template>
  <div class="filter-wrapper">
    <div class="filter-options">
      <v-form ref="form">
        <v-row dense>
          <v-col cols="12" md="4">
            <v-text-field
              v-model="name"
              label="Tên hoặc mã đầu mục"
              placeholder="Nhập tên hoặc mã đầu mục..."
              outlined
              dense
              clearable
              hide-details
              @keyup.enter="onFilterChanged"
            />
          </v-col>
          <v-col cols="12" md="4">
            <v-text-field
              v-model="tags"
              label="Thẻ đính kèm (Tags)"
              placeholder="Nhập thẻ đính kèm..."
              outlined
              dense
              clearable
              hide-details
              @keyup.enter="onFilterChanged"
            />
          </v-col>
        </v-row>
      </v-form>
    </div>
    <div class="filter-submit">
      <v-btn class="search-button" @click="onFilterChanged" outlined>
        Tìm kiếm
      </v-btn>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CategoryFilter',
  data: () => ({
    tags: '',
    name: ''
  }),
  mounted() {
    this.onFilterChanged()
  },
  methods: {
    onFilterChanged() {
      const params = {}
      if (this.tags && this.tags.trim()) {
        params.tags_contains = this.tags.trim()
      }
      if (this.name && this.name.trim()) {
        params.keyword = this.name.trim()
      }
      this.$emit('onFilterChanged', params)
    }
  }
}
</script>

<style lang="scss" scoped>
.filter-wrapper {
  display: flex;
  gap: 24px;
  @media screen and (max-width: 960px) {
    flex-direction: column;
  }
  .filter-options {
    flex: 1;
  }
  .filter-submit {
    margin-left: auto;
    align-self: flex-end;
  }
}
</style>
